import React from 'react';

// DESIGN V2 — tab strip used under the nav (Discover: For You / Mixpedia /
// Crate Digger / Set Planner) and inside pages (hero: Overview / Tracks / …).
// items: [{ key, label, count? }], value: active key.
export default function PageTabs({ items, value, onChange, className = '' }) {
    return (
        <div className={`v2-tabs ${className}`} role="tablist">
            {items.map((t) => (
                <button key={t.key} type="button" role="tab" aria-selected={value === t.key} className={value === t.key ? 'on' : ''} onClick={() => onChange(t.key)}>
                    {t.label}{t.count != null && <span className="v2-faint v2-num" style={{ marginLeft: 6 }}>{t.count}</span>}
                </button>
            ))}
        </div>
    );
}

export function SectionHeader({ title, count, link, onLink, children }) {
    return (
        <div className="v2-section">
            <h2>{title}</h2>
            {count != null && <small className="v2-num">{count}</small>}
            {children}
            {link && <button type="button" className="v2-section-link" onClick={onLink}>{link} ›</button>}
        </div>
    );
}
